import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import {
  FormContainerWithHeader,
  BoxLayout,
  DialogLayoutHr,
} from '../../../../presentation';
import './underwriting.overview.clearance.scss';
import { Grid } from '@mui/material';

interface IClearanceData {
  message: string;
  clearedBy: string;
  clearanceNotes: string[];
  isSuccess: boolean;
}

export const UnderwritingOverviewClearanceFormSection = ({
  isReadonly = false,
}: {
  isReadonly?: boolean;
} = {}) => {
  const { t } = useTranslation();
  const clearanceData: IClearanceData[] = [
    {
      message: 'Manually cleared at 1/2/2023 at 3:51pm',
      clearedBy: 'John Smith',
      clearanceNotes: [
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec fringilla fermentum urna. Pellentesque id tincidunt lectus. Integer volutpat accumsan mattis. Nullam euismod, arcu eget accumsan vestibulum, magna ex consequat nibh, in convallis leo orci vitae arcu. Integer efficitur vulputate lacinia. Morbi ac eros vel arcu semper accumsan sit amet id magna. Integer elementum feugiat interdum. Praesent convallis, lectus at laoreet egestas, felis magna rhoncus urna, dignissim dapibus sem magna vitae mauris. Nam ante sapien, eleifend vel lectus non, cursus fermentum elit. Sed malesuada purus eu metus interdum dapibus. Nulla eget magna est. Vivamus tincidunt, enim a pulvinar suscipit, tellus ligula efficitur enim, in dapibus metus metus id justo. Etiam enim elit, luctus a ex vel, feugiat consectetur libero. Aenean eget condimentum sem. Duis sed nisl vitae elit aliquam mattis a sed dolor.',
      ],
      isSuccess: true,
    },
    {
      message: 'Clearance failed on 1/2/2023 at 3:42pm',
      clearedBy: 'John Smith',
      clearanceNotes: ['Broker of Record (BOR) is not appointed'],
      isSuccess: false,
    },
    {
      message: 'Clearance failed on 1/2/2023 at 3:21pm',
      clearedBy: 'John Smith',
      clearanceNotes: [
        'Insured is possibly on sanctions list',
        'Broker of Record (BOR) is not appointed',
      ],
      isSuccess: false,
    },
  ];

  return (
    <FormContainerWithHeader
      title={t(
        'underwriting.detail.content.sections.clearance.title',
        'Clearance'
      )}
    >
      <Grid className="underwriting-overview-clearance-section" item>
        {clearanceData.map((data, index) => (
          <BoxLayout
            className="underwriting-overview-clearance-box"
            key={index}
          >
            <ClearanceSectionHeader {...data} />
            <ClearanceSectionBody {...data} />
          </BoxLayout>
        ))}
      </Grid>
    </FormContainerWithHeader>
  );
};

const ClearanceSectionHeader = (clearanceData: IClearanceData) => {
  return (
    <>
      <div
        className={
          clearanceData.isSuccess
            ? 'underwriting-overview-clearance-header success-header'
            : 'underwriting-overview-clearance-header failed-header'
        }
      >
        <div className="underwriting-overview-clearance-header-info">
          {clearanceData.isSuccess ? (
            <DoneIcon color="success" />
          ) : (
            <CloseIcon color="error" />
          )}
          <span style={{ fontWeight: 'bold', paddingLeft: '10px' }}>
            {clearanceData.message}
          </span>
        </div>
        <span>{clearanceData.clearedBy}</span>
      </div>
      <DialogLayoutHr color={clearanceData.isSuccess ? 'success' : 'error'} />
    </>
  );
};

const ClearanceSectionBody = (clearanceData: IClearanceData) => {
  return (
    <div className="underwriting-overview-clearance-body">
      {clearanceData.isSuccess ? (
        <span>{clearanceData.clearanceNotes[0]}</span>
      ) : (
        <ul>
          {clearanceData.clearanceNotes.map((note, index) => (
            <li key={index}>{note}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
